import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import SoundType from "../../../core/sound/util/SoundType";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import TextTypeWriterAnimation from "../../../core/ui/animation/typewriters/TextTypeWriterAnimation";
import MovieClipUtil from "../../util/MovieClipUtil";
import PromiseUtil from "../../util/PromiseUtil";

export default class ConversationHintMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {OverlayFactory} overlayFactory 
     * @param {SoundManager} soundManager 
     */
    constructor(target, dispatcher, layoutManager, overlayFactory, soundManager) {
        super(target, dispatcher, layoutManager, overlayFactory);

        this._soundManager = soundManager;
    }

    initialize() {
        super.initialize();

        this._target.initialY = this._target.y;
        this._target.hideY = this._target.initialY + ConversationHintMediator.HIDE_Y_OFFSET;

        this._slice9Panel = new Slice9Panel(this._target, MovieClipUtil.getFirstBitmapChild(this._target), {
            mode: Slice9Panel.VERTICAL,
            pixelPerfect: true,
            overlap: false,
        });
    }

    hideInstant() {
        this._target.alpha = 0;
        this._target.y = this._target.hideY;
    }

    async showHint(text) {
        this._target.contentText.text = text;
        this._slice9Panel.update();
        const deltaHeight = this._slice9Panel.getDeltaHeight();
        this._target.contentText.text = "";

        this._target.y = this._target.hideY;
        this._target.visible = true;
        await createjs.Tween.get(this._target)
            .to({
                alpha: 1,
                y: this._target.initialY - deltaHeight,
            }, 450, createjs.Ease.sineInOut)
            .toPromise();

        await PromiseUtil.delay(150);
        await this._typeWriteText(text);
    }

    async hide() {
        this._soundManager.stopSound(this._typewriteSoundId, 150);

        createjs.Tween.removeTweens(this._target);
        await createjs.Tween.get(this._target)
            .to({ alpha: 0 }, 150, createjs.Ease.sineInOut)
            .call(() => {
                this._target.visible = false;
            })
            .toPromise();
    }

    async _typeWriteText(text) {
        this._typewriteSoundId = this._soundManager.playSound(SoundType.TYPEWRITER_COACH, null, null, 0, 0, -1);
        await new Promise(resolve => {
            this._target.contentText.text = "";

            const duration = text.length * .015;
            TextTypeWriterAnimation.animate(this._target.contentText, text, duration, 0, resolve);
        });
        this._soundManager.stopSound(this._typewriteSoundId, 50);
    }
}

ConversationHintMediator.HIDE_Y_OFFSET = 50;